import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.fermentGroups;

export default class FermentGroups extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      categories: this.attr([]),
    };
  }

  static methodConf = {
    http: {
      url: '/catalog/ferments',
    },
  };
}
